<div class="row">
    <div class="col-12">
        <div id="clientList" class="card">
            <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems"
                [listService]="importEntitiesListService" (buttonActionSelected)="buttonActionSelected($event)"
                (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
                (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
                (searchTermChanged)="importEntitiesListService.searchTerm = $event"
                (resetListLayout) = "importEntitiesListService.resetListState($event)"
                (paginationSelected)="paginationUpdated(importEntitiesListService,$event)" [serviceData]="serviceData"
                (pageSizeSelected)="importEntitiesListService.pageSize = $event"></app-list-layout>
        </div>
    </div>
</div>